import React, { useState, Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter, browserHistory } from 'react-router';
import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import {
  useSelector,
  useDispatch,
} from '../components/common/react-redux-hooks';
import CacProjectTabs from '../components/corrCluster/CacProjectTabs';
import CorrClusterTeaser from '../components/corrCluster/Correspondence/CorrClusterTeaser';
import { isFeaturePresent } from '../util/CommonUtils';
import { saveTrackingData } from '../util/trackerUtils';
import { 
  CORRCLUSTER_FEATUREID,
  CLUSTER_CORRESPONDENCE_MODULE 
} from '../constants';
import { CAC_EXPORT } from '../trackerConstants';

import { 
  CAC_NO_STUDIES,
  CAC_LEFT_PANEL_VIEW_LABEL,
 } from '../components/corrCluster/CacConstants';
import {
  setCACProjectToActive,
  saveCACActiveProject,
  creatCACProject,
  showSavedCacProjects,
  removeTempTitle,
  editProjectTabName,
  openSelectedProjects,
  duplicateProject,
  cacCloseProject,
  exportCACProject,
} from '../actions/cacActions';
import {
  CAC_LEFT_PANEL_BUILD_LABEL,
  CAC_COLUMN_ROW_CROSSTAB_MIN_COUNT,
  CAC_MAXIMUM_PROJECT_COUNT,
  HANDLE_VIEW_SWITCH_EVENT,
} from '../components/corrCluster/CacConstants';
// import LazyLoader from '../components/common/LazyLoader';
import CacSaveOpenPanel from '../components/corrCluster/CacSaveOpenPanel';
import CacModals from '../components/corrCluster/modals/CacModals';
import { toastSuccess, toastError } from '../util/toastUtils';
import ProjectContext from '../components/corrCluster/context/ProjectContext';
import CacProjectContent from '../components/corrCluster/CacProjectContent';
// const ProjectContent = lazy(() => import('../components/corrCluster/ProjectContent'));
import SaveBeforeCloseModal from '../components/corrCluster/modals/SaveBeforeCloseModal';
import { 
  getCacActiveProject, 
  getProjectDetailsToSave, 
  hasUnsavedChanges,
  getApiRequestParameter,
  getChartViewName
 } from '../util/cacUtils';
import RouterLeaveModal from '../components/corrCluster/modals/RouterLeaveModal';
import WarningIcon from './WarningIcon';

let leaveRouteProjects;
let leaveRouteActiveProjectId;
let navConfirmed = false;
const CacContainer = props => {
  CacContainer.contextTypes = {
    router: PropTypes.object,
  };
  const [saveWarningModal, setSaveWarningModal] = useState(false);
  const [saveAsModal, setSaveAsModal] = useState(false);
  const [maxLimitModal, showMaxLimitModal] = useState(false);
  const [savedProjects, setSavedProjects] = useState([]);
  const [noSavedProjects, setNoSavedProjects] = useState(false);
  const [closeProjectModal, setCloseProjectModal] = useState(false);
  const [closeProject, setCloseProject] = useState(false);
  const [saveFromCloseProject, setSaveFromCloseProject] = useState(false);
  const [routerLeaveModal, setRouterLeaveModal] = useState(false);
  const [nextLocation, setNextLocation] = useState('');

  const {
    projects,
    activeProjectId,
    permissions,
    userId,
    currentAccountId,
    hasCaCStudies,
  } = useSelector(state => ({
    projects: state.correspondenceCluster.projects,
    activeProjectId: state.correspondenceCluster.activeProjectId,
    permissions: state.userDetail.permissions,
    userId: state.login.loginResponse.data.userId,
    currentAccountId: state.login.loginResponse.data.currentAccountId,
    hasCaCStudies: state.study.hasCaCStudies,
  }));
  const hasModuleAccess = isFeaturePresent(CORRCLUSTER_FEATUREID, permissions);
  const dispatch = useDispatch();

  leaveRouteProjects = cloneDeep(projects);
  leaveRouteActiveProjectId = activeProjectId;

  const handleCloseProject = () => {
    if (closeProject) {
      dispatch(cacCloseProject());
      setCloseProject(false);
    }
  };

  const openCloseProjectModal = () => {
    if (
      !projects.find(item => item.projectId === activeProjectId).isProjectSaved
    ) {
      setCloseProjectModal(true);
    } else {
      setCloseProject(true);
    }
  };

  const duplicateActiveProject = () => {
    if (projects.length < CAC_MAXIMUM_PROJECT_COUNT) {
      dispatch(duplicateProject());
    } else {
      showMaxLimitModal(true);
    }
  };

  const handleEditTabName = updatedObjectProps => {
    dispatch(editProjectTabName(updatedObjectProps, activeProjectId));
  };

  const addNewProject = () => {
    const viewMode = CAC_LEFT_PANEL_BUILD_LABEL;
    if (projects.length < CAC_MAXIMUM_PROJECT_COUNT) {
      dispatch(creatCACProject({ viewMode }));
    } else {
      showMaxLimitModal(true);
    }
  };

  const setActiveProject = (selectedProjectId, activeProjectId) => {
    dispatch(setCACProjectToActive(selectedProjectId, activeProjectId));
  };

  const closeSaveAsModal = () => {
    setSaveAsModal(false);
    dispatch(removeTempTitle(activeProjectId));
  };

  const saveProject = ({ title, pid, newProject, closeProject }) => {
    const isRenamed = !!title;
    const project = getCacActiveProject(projects, activeProjectId);
    title = title || project.title;

    const { rows, columns } = project;
    if (
      rows &&
      rows.length >= CAC_COLUMN_ROW_CROSSTAB_MIN_COUNT &&
      columns &&
      columns.length >= CAC_COLUMN_ROW_CROSSTAB_MIN_COUNT
    ) {
      // getProjectDetailsToSave method is the place to filter data needed to save
      const detailsToSave = getProjectDetailsToSave(project);
      dispatch(
        saveCACActiveProject({
          userId,
          currentAccountId,
          isRenamed,
          pid,
          title,
          activeProjectId,
          newProject,
          closeProject,
          detailsToSave,
        })
      ).then(res => {
        if (res.status) {
          if (res.closeProject) {
            setCloseProject(true);
            setSaveFromCloseProject(false);
          }
          toastSuccess('Project saved successfully');
        } else if (res.message === 'duplicate') {
          setSaveAsModal(true);
        } else {
          toastError('Unable to save the project');
        }
      });
    } else {
      setSaveWarningModal(true);
    }
  };

  const exportProject = (project) => {
    const projectObj = getApiRequestParameter(
      project,
      CAC_LEFT_PANEL_VIEW_LABEL,
      '',
      HANDLE_VIEW_SWITCH_EVENT
    );
    projectObj.chartViewName = getChartViewName(project.chartView);
    saveTrackingData({
      uid: userId,
      accid: currentAccountId,
      productNo: project && project.study && project.study.pn,
      moduleName: CLUSTER_CORRESPONDENCE_MODULE,
      action: CAC_EXPORT,
    });

    dispatch(exportCACProject({ userId, currentAccountId, ...projectObj }));
  }

  const callSaveProject = () => {
    const pid = getCacActiveProject(projects, activeProjectId).pid || 0;
    saveProject({ pid });
  };

  const openSavedProjects = () => {
    showSavedCacProjects(userId, currentAccountId).then(response => {
      if (response.length > 0) {
        const cacSavedList = response.map(entry => ({
          id: entry.pid,
          title: entry.title,
          lastModified: moment(entry.lastModified).format('MM/D/YYYY hh:mm A'),
          lastModifiedSortable: entry.lastModified,
        }));
        setSavedProjects(cacSavedList);
      } else {
        setNoSavedProjects(true);
      }
    });
  };

  const setSelectedToActive = selectedProjectPid => {
    const [projectId] = projects
      .filter(project => project.pid === selectedProjectPid)
      .map(project => project.projectId);
    setActiveProject(projectId);
  };

  const getSelectedProjects = (pids, selectedProjectPid) => {
    if (selectedProjectPid) {
      const [projectId] = projects
        .filter(project => project.pid === selectedProjectPid)
        .map(project => project.projectId);
      dispatch(openSelectedProjects(userId, currentAccountId, pids, projectId));
    } else {
      dispatch(openSelectedProjects(userId, currentAccountId, pids));
    }
  };

  const handleCloseOpen = () => {
    setNoSavedProjects(false);
    setSavedProjects([]);
  };

  const showMaxLimitPopup = () => {
    showMaxLimitModal(true);
  };
 
  const confirmNavigation = () => {
    navConfirmed = true;
    setRouterLeaveModal(false);
    browserHistory.push(nextLocation)
  }

  const routerWillLeave = nextLocation => {
    if (
      leaveRouteProjects &&
      leaveRouteProjects.length > 0 &&
      !leaveRouteProjects.find(
        item => item.projectId === leaveRouteActiveProjectId
      ).isProjectSaved &&
      !navConfirmed
    ) {
      setNextLocation(nextLocation.pathname);
      setRouterLeaveModal(true);
      return false;
    }
    navConfirmed = false;
    return true;
  };

  const beforeunload = (e) => {
    const isIdle = sessionStorage.getItem('isIdle');
    const unSavedChange = hasUnsavedChanges(leaveRouteProjects); 
    if (unSavedChange && !JSON.parse(isIdle)) {
      e.preventDefault();
      e.returnValue = true;
    }
  };

  useEffect(() => {
    // event for closing CAC at browser level 
    window.addEventListener('beforeunload', beforeunload);
    // method to prompt user on leaving module for unsaved changes
    props.router.setRouteLeaveHook(props.route, routerWillLeave);
    return () => {
      // detaching event 
      window.removeEventListener('beforeunload', beforeunload);
    };
  }, []);

  useEffect(() => {
    handleCloseProject(); // this is a fuction which close project
  }, [closeProject]);

  const renderProjectContent = () => {
    if (projects.length !== 0) {
      return (
        <ProjectContext.Provider
          value={{ addNewProject, duplicateActiveProject, handleEditTabName }}
        >
          <CacProjectContent
            project={getCacActiveProject(projects, activeProjectId)}
            activeProjectId={activeProjectId}
          />
        </ProjectContext.Provider>
      );
    }
    return addNewProject();
  };

  const renderContent = () => {
    return (
      <div className="CacContainer">
        <div className="CacContainer-flex">
          <CacProjectTabs
            activeProjectId={activeProjectId}
            projects={projects.map(({ projectId, title }) => ({
              projectId,
              title,
            }))}
            addNewProject={addNewProject}
            setActiveProject={setActiveProject}
            handleEditTabName={handleEditTabName}
            openCloseProjectModal={openCloseProjectModal}
          />
          <CacSaveOpenPanel
            project={getCacActiveProject(projects, activeProjectId)}
            activeProjectId={activeProjectId}
            savedProjects={savedProjects}
            openSavedProjects={openSavedProjects}
            callSaveProject={callSaveProject}
            getSelectedProjects={getSelectedProjects}
            noSavedProjects={noSavedProjects}
            handleCloseOpen={handleCloseOpen}
            projectCount={projects.length}
            openedProjectIds={projects.map(project => project.pid)}
            setSelectedToActive={setSelectedToActive}
            exportProject={exportProject}
          />
        </div>
        {renderProjectContent()}
        {saveWarningModal || saveAsModal || maxLimitModal ? (
          <CacModals
            saveWarningModal={saveWarningModal}
            setSaveWarningModal={() => setSaveWarningModal(false)}
            saveAsModal={saveAsModal}
            setSaveAsModal={() => setSaveAsModal(false)}
            projectName={getCacActiveProject(projects, activeProjectId).title}
            saveProject={saveProject}
            tempTitle={getCacActiveProject(projects, activeProjectId).tempTitle}
            pid={getCacActiveProject(projects, activeProjectId).pid}
            projectCount={projects.length}
            showMaxLimitPopup={showMaxLimitPopup}
            showMaxLimitModal={() => showMaxLimitModal(false)}
            maxLimitModal={maxLimitModal}
            closeSaveAsModal={closeSaveAsModal}
            saveFromCloseProject={saveFromCloseProject}
            setSaveFromCloseProject={setSaveFromCloseProject}
          />
        ) : null}
        {closeProjectModal ? (
          <SaveBeforeCloseModal
            closeProjectModal={closeProjectModal}
            setCloseProjectModal={() => setCloseProjectModal(false)}
            tempTitle={getCacActiveProject(projects, activeProjectId).tempTitle}
            projectName={getCacActiveProject(projects, activeProjectId).title}
            saveProject={saveProject}
            setCloseProject={setCloseProject}
            setSaveFromCloseProject={setSaveFromCloseProject}
            pid={getCacActiveProject(projects, activeProjectId).pid}
          />
        ) : null}
        {routerLeaveModal ? (
          <RouterLeaveModal
            routerLeaveModal={routerLeaveModal}
            setRouterLeaveModal={setRouterLeaveModal}
            confirmNavigation={confirmNavigation}
          />
        ) : null}
      </div>
    );
  };

  return (
    <Fragment>
      {hasCaCStudies ? (
        hasModuleAccess ? (
          renderContent()
        ) : (
          <CorrClusterTeaser />
        )
      ) : (hasCaCStudies !== undefined) && ( // loading
        <div className="no-study-message">
          <WarningIcon />
          <p>{CAC_NO_STUDIES}</p>
        </div>
      )}
    </Fragment>
  );
};

export default withRouter(CacContainer);
